export const Entitlement = {
    ApiKeys: 'api-keys',
    AutoExtendSeatedBookings: 'auto-extend-seated-bookings',
    BookingOutcomeReporting: 'booking-outcome-reporting',
    BookingSlotBookingLimits: 'booking-slot-booking-limits',
    BookingSlotCoverLimits: 'booking-slot-cover-limits',
    CancellationReasons: 'cancellation-reasons',
    CustomerAcceptanceCustomisation: 'customer-acceptance-customisation',
    CustomQuestions: 'custom-questions',
    DiningInformation: 'dining-information',
    DogFriendlyAllowedTimes: 'dog-friendly-allowed-times',
    EmailMarketingIntegrations: 'email-marketing-integrations',
    EmbeddableBookingWidget: 'embeddable-booking-widget',
    GiftVoucherReporting: 'gift-voucher-reporting',
    LargePartyMessage: 'large-party-message',
    MaxDogFriendlyActiveLimit: 'max-dog-friendly-active-limit',
    // This existing entitlement also covers highchair-friendly active booking limits.
    MaxPramActiveLimit: 'max-pram-active-limit',
    MetaTracking: 'meta-tracking',
    PosIntegrations: 'pos-integrations',
    ReasonBookingCutOffTimeOverride: 'reason-booking-cut-off-time-override',
    ReasonBookingDurationOverrides: 'reason-booking-duration-overrides',
    ReasonDiningInformation: 'reason-dining-information',
    ReasonLargePartyNoAvailabilityMessage: 'reason-large-party-no-availability-message',
    ReasonLinkExclusive: 'reason-link-exclusive',
    ReasonLimit: 'reason-limit',
    ReasonLimits: 'reason-limits',
    ReasonMaximumPartySize: 'reason-maximum-party-size',
    ReasonMenus: 'reason-menus',
    ReasonMinimumPartySize: 'reason-minimum-party-size',
    RyftPayments: 'ryft-payments',
    ScheduleLimits: 'schedule-limits',
    ServiceStatuses: 'service-statuses',
    ShortSelling: 'short-selling',
    TooCloseToBookingTimeMessage: 'too-close-to-booking-time-message',
    UtmSources: 'utm-sources',
    VenueStorefront: 'venue-storefront',
    Waitlists: 'waitlists',
} as const

export type EntitlementName = typeof Entitlement[keyof typeof Entitlement]
